
export default function AmendmentStateNb (props)
{
    let classes = "text-uppercase";
    let text = "";

    const nb = props.nb === undefined ? 0 : props.nb;
    
    switch (props.state)
    {
	case "draft" :
	classes += " text-secondary";
	text = "rédigé" + (nb > 1 ? "s" : "");
	break;
	
	case "waiting" :
	classes += " text-secondary";
	text = "rédigé" + (nb > 1 ? "s" : "");
	break;
	
	case "submitted" :
	classes += " text-dark";
	text = "déposé" + (nb > 1 ? "s" : "");
	break;
	
	case "accepted" :
	classes += " text-success";
	text = "adopté" + (nb > 1 ? "s" : "");
	break;
	
	case "rejected" :
	classes += " text-danger";
	text = "rejeté" + (nb > 1 ? "s" : "");
	break;
	
	case "canceled" :
	classes += " text-secondary";
	text = "annulé" + (nb > 1 ? "s" : "");
	break;
	
	case "deleted" :
	classes += " text-warning";
	text = "supprimé" + (nb > 1 ? "s" : "");
	break;
	
	default :
    }

    if (props.nb === undefined) return (<span className={classes}>{text}</span>);
    else return (<span className={classes}>{nb} {text}</span>);
}
